document.addEventListener('DOMContentLoaded', () => {
	const newsletterModal = document.getElementById('newsletter-modal');
	const closeNewsletterModal = document.querySelectorAll(
		'#newsletter-modal button.close-button, #newsletter-modal .modal-bg',
	);
	const openNewsletterButtons = document.querySelectorAll('.newsletter-button');

	openNewsletterButtons.forEach((button) => {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			newsletterModal.classList.add('open');
			document.body.classList.add('modal-open');
		});
	});
	closeNewsletterModal.forEach((button) => {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			newsletterModal.classList.remove('open');
			document.body.classList.remove('modal-open');
		});
	});
});
